import BaseModel from '@/models/Base';
import Membership from '@/models/core/Membership';

export default class Enclosure extends BaseModel {
  static entity = 'enclosures';

  static fields() {
    return {
      ...super.fields(),
      url: this.string(''),
      type: this.string(''),
      dimensions: this.attr('object')
    };
  }

  get isImage() {
    return this.type.indexOf('image') > -1;
  }

  get isVideo() {
    return this.type.indexOf('video') > -1;
  }

  get proxyUrl() {
    return `/proxy?url=${this.url}`;
  }
}
